<template>
  <div>
    <h3 class="modal-title"> EMBED URL </h3>

    <b-form-group :class="{'error-input' : $v.data_embed_url.title.$error}">
      <label> Title </label>
      <j-input
        v-model="$v.data_embed_url.title.$model"
        :max-length="255"
        placeholder="Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_embed_url.url.$error}">
      <label> URL </label>
      <j-input
        v-model="$v.data_embed_url.url.$model"
        placeholder="https://"/>
    </b-form-group>

    <div class="warning-message">
      <img src="@/assets/icon/warning.svg">
      <div class="d-flex flex-column">
        <p class="warning-title">Information</p>
        <p class="warning-text">
          URL must use HTTPS (Hypertext Transfer Protocol Secure)
        </p>
      </div>
    </div>

    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeEmbedUrl">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveEmbedUrl">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_embed_url: {
      title: {
        required,
      },
      url: {
        required,
      },
    },
  },
  data() {
    return {
      data_embed_url: {
        title: '',
        url: '',
      },
    };
  },
  computed: {
    generateDataEmbedUrl() {
      const data = {
        value_id: '0',
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_embed_url.title,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify({
          url: this.data_embed_url.url,
        }),
        type_platform: 1,
      };
      return data;
    },

    generateDataEmbedUrlUpdate() {
      const data = {
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_embed_url.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        info: JSON.stringify({
          url: this.data_embed_url.url,
        }),
        type_platform: 1,
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      this.data_embed_url.title = this.dataEdit.name;
      this.data_embed_url.url = JSON.parse(this.dataEdit.info).url;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent']),

    saveEmbedUrl() {
      this.$v.data_embed_url.$touch();
      if (!this.$v.data_embed_url.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataEmbedUrl,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataEmbedUrlUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeEmbedUrl();
      }
    },

    closeEmbedUrl() {
      this.$emit('close-field');
      this.data_embed_url.title = '';
      this.data_embed_url.analytic = '';
      setTimeout(() => {
        this.$v.data_embed_url.$reset();
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
  .warning-message {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 12px;
    background-color: rgba(255, 249, 195, 0.31);
    border-radius: 8px;
    margin-bottom: 16px;

    img {
      width: 14px;
      height: 14px;
      margin-right: 12px;
    }
    .warning-title {
      font-family: 'Poppins-Medium';
      font-size: 12px;
      color: #696014;
      margin-bottom: 2px;
    }
    .warning-text {
      font-family: 'Poppins-Regular';
      font-size: 12px;
      color: #696014;
      margin-bottom: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jEmbedUrlSetup.vue